import { useMemo } from 'react';
import { TableRegions } from '../TableRegions';
import { hasSelectionColumn } from './internal';
import cn from '../Table.css.json';
export const useDefaultAction = props => {
  const {
    columns,
    rowCount,
    selectionMode,
    initialFocus,
    onActivate
  } = props;
  const cellInfo = useMemo(() => {
    const rowIndex = initialFocus?.rowIndex ?? 0;
    const colIndex = initialFocus?.colIndex ?? 0;
    const columnKey = columns[colIndex] && columns[colIndex].key;
    const firstDataColIndex = hasSelectionColumn(selectionMode, columns.length, rowCount) ? 1 : 0;
    const getRegionForCellPosition = () => {
      if (rowIndex < 0 && colIndex < 0) {
        return TableRegions.ColumnHeaderButton;
      } else if (colIndex < firstDataColIndex) {
        return rowIndex < 0 ? TableRegions.ColumnRowHeader : TableRegions.RowHeader;
      } else if (rowIndex < 0) {
        return TableRegions.ColumnHeader;
      }
      return TableRegions.Data;
    };
    const region = getRegionForCellPosition();
    return {
      rowIndex,
      colIndex,
      region,
      columnKey,
      column: columns[colIndex]
    };
  }, [selectionMode, initialFocus, columns, rowCount]);
  const cellActivated = useMemo(() => {
    const {
      region,
      column
    } = cellInfo;
    const hasInteraction = !!(column?.onPress || column?.containsInteractiveContent && !column?.onActivate
    // a column already has an interaction if containsInteractiveContent is true
    // and activateOnEnter is false and onActivate is undefined for the column,
    // which means Enter press will put the cell into edit mode
    );

    return props.onActivate && (region === TableRegions.Data || region === TableRegions.RowHeader) && !hasInteraction;
  }, [props.onActivate, cellInfo]);
  const {
    rowIndex,
    colIndex,
    columnKey,
    column
  } = cellInfo;
  const onEvent = event => {
    // activate cell in list and table on Enter
    if (cellActivated && (!event || event.key === 'Enter' && !event.ctrlKey && !event.metaKey)) {
      onActivate?.(rowIndex, colIndex, columnKey, false);
    }
  };
  const onClick = event => {
    const target = event.target;
    const isCellArea = target.matches(`.${cn.gridCellContentContainer}, .${cn.gridCellContent}`);
    const isRowContent = !!target.closest(`.${cn.row}`);
    let node = isRowContent ? target : null;
    while (node?.hasChildNodes() && node.firstChild instanceof HTMLElement) {
      node = node.firstChild;
    }
    // make sure this is not an empty row
    const hasCellContent = !!node?.closest(`.${cn.gridCellContent}`) || !!node?.closest(`.${cn.selectionCell}`);

    // If a cell has interactive content or a list cell uses onPress
    // only fire onActivate if the user is clicking on an empty part of the cell.
    if (column?.containsInteractiveContent || column?.onPress) {
      if (isCellArea) {
        onActivate?.(rowIndex, colIndex, columnKey, true);
      }
    } else {
      // do not call onActivate if the user clicked outside of a row
      // (such as the empty space below the last row )
      if (isRowContent && hasCellContent) {
        onActivate?.(rowIndex, colIndex, columnKey, true);
      }
    }
  };
  return {
    onClick,
    onKeyUp: onEvent
  };
};
//# sourceMappingURL=useDefaultAction.js.map